import { render, staticRenderFns } from "./alarmDialogStatic.vue?vue&type=template&id=c84fb666&scoped=true&"
import script from "./alarmDialogStatic.vue?vue&type=script&lang=ts&"
export * from "./alarmDialogStatic.vue?vue&type=script&lang=ts&"
import style0 from "./alarmDialogStatic.vue?vue&type=style&index=0&id=c84fb666&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84fb666",
  null
  
)

export default component.exports